import { Paperclip } from "lucide-react";
import { CircularProgress } from "@mui/material";
import { cn } from "@/lib/utils";

interface DocumentCardProps {
  doc: any;
  index: number;
  filledDoc?: any;
  isLoading: boolean;
  hasBindingQuestion?: boolean;
  onDownload: (path: string) => void;
  onUpload?: (docId: string) => void;
  forceAllowAction?: boolean;
}

export function DocumentCard({
  doc,
  index,
  filledDoc,
  isLoading,
  hasBindingQuestion,
  onDownload,
  onUpload,
  forceAllowAction,
}: DocumentCardProps) {
  const isFilled = !!(filledDoc && filledDoc.path);
  const filledPath = isFilled ? filledDoc.path.replace(/[`]/g, "").trim() : "";
  const canAction =
    forceAllowAction || isFilled || (hasBindingQuestion && !!onUpload);

  console.log("DOCUMENTO:", doc);

  const handleCardClick = () => {
    if (isLoading) return;
    if (forceAllowAction) {
      onDownload("");
      return;
    }
    if (isFilled && filledPath) {
      onDownload(filledPath);
    } else if (hasBindingQuestion && onUpload) {
      onUpload(doc._id);
    }
  };

  return (
    <div
      className={cn(
        "border rounded-2xl aspect-square flex flex-col overflow-hidden transition-all group relative bg-gray-50",
        canAction
          ? "cursor-pointer hover:shadow-md"
          : "cursor-not-allowed opacity-70",
        isFilled ? "border-blue-100" : "border-gray-200",
      )}
      onClick={handleCardClick}
    >
      {/* Clip Icon Badge */}
      <div className="absolute top-3 right-3 z-10">
        <div
          className={cn(
            "p-2 rounded-2xl shadow-md transition-all",
            isFilled ? "bg-white" : "bg-white/60",
          )}
        >
          {isLoading ? (
            <CircularProgress size={18} />
          ) : (
            <Paperclip
              className={cn(
                "size-5 transition-colors",
                isFilled ? "text-blue-600" : "text-gray-400",
              )}
            />
          )}
        </div>
      </div>

      {/* Preview Area */}
      <div className="flex-1 flex items-center justify-center overflow-hidden relative">
        {isFilled ? (
          <img
            src={filledPath}
            alt={doc?.name}
            className="w-full h-full object-contain opacity-80 p-4"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
        ) : (
          <div className="w-full h-full bg-gray-100/50" />
        )}
      </div>

      {/* Footer */}
      <div className="px-3 py-2 bg-white border-t border-gray-50 text-xs text-gray-500 flex flex-col shrink-0">
        <span className="font-medium text-xs truncate">
          {doc?.name || "Documento"} {String(index + 1).padStart(2, "0")}
        </span>
        {isFilled && (
          <span className="font-medium text-xs truncate">
            {new Date(filledDoc?.createdAt || new Date()).toLocaleDateString(
              "pt-BR",
              {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit",
              },
            )}
            {" | "}
            {new Date(filledDoc?.createdAt || new Date()).toLocaleTimeString(
              "pt-BR",
              {
                hour: "2-digit",
                minute: "2-digit",
              },
            )}
          </span>
        )}
      </div>
    </div>
  );
}
